// src/api/modules/FirstPickupApi.js
import Methods from "../methods";

/**
 * Busca recojos con filtros y paginación
 */
const searchPickups = (context, idClient, payload) => {
  const { filters, page, size } = payload;
  const url = `/first-pickups/search/${idClient}?page=${page}&size=${size}`;
  return Methods.doPost(context, url, filters, null);
};

/**
 * Guarda una lista de solicitudes de recojo en batch (agrupadas por orden)
 */
const saveBatchPickups = (context, payload) => {
  const url = `/first-pickups/save-batch`;
  return Methods.doPost(context, url, payload, null);
};

export default {
  searchPickups,
  saveBatchPickups
};



// WEBPACK FOOTER //
// ./src/api/modules/FirstPickupApi.js